/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { isBrowser } from 'react-device-detect';
import PropTypes from 'prop-types';
import ModalBodyLayout from '../../../shared/ModalBodyLayout';
import { SendCryptoScreensFlow } from '../../constants';
import ChecklistOption from '../../../../components/Checklist';
import { tagColors } from './constants';
import { maskCoinAddress } from '../../../../utilities/helpers';

const WhitelistDeleteAddress = ({ openScreen, wallet, options, isSendCryptoModal }) => {
  const { t: translate } = useTranslation();
  const { selectedWallet, selectedWalletTag } = options;

  const deleteWhitelistedWallet = () => {
    openScreen(SendCryptoScreensFlow.WHITELIST_VERIFY, {
      selectedWallet,
      isDelete: true,
    });
  };
  const manageScreen = () => {
    openScreen(SendCryptoScreensFlow.WHITELIST_MANAGE_ADDRESSES);
  };

  const renderTitle = () => (
    <div
      className={`w-100 ${
        isBrowser ? 'd-flex align-items-center justify-content-between mb-5' : ''
      } `}>
      <div>
        <b className="text-f5 text-dark ms-2">
          {translate('whitelist_title_remove_whitelisted').replace(
            '%s',
            wallet?.coin?.toUpperCase()
          )}
        </b>
      </div>
    </div>
  );

  const renderFooter = () => (
    <div className="d-flex flex-row align-items-center justify-content-between mt-auto w-100">
      <button
        onClick={manageScreen}
        className="btn btn-outline-shadow text-light w-45"
        type="submit">
        {translate('cancel_button_label')}
      </button>
      <button onClick={deleteWhitelistedWallet} className="btn btn-primary w-45" type="submit">
        {translate('confirm_button_label')}
      </button>
    </div>
  );

  return (
    <ModalBodyLayout
      withBack
      onPrevClick={() =>
        openScreen(
          isSendCryptoModal
            ? SendCryptoScreensFlow.SEND_CRYPTO
            : SendCryptoScreensFlow.WHITELIST_MANAGE_ADDRESSES
        )
      }
      renderFooter={renderFooter}
      renderTitle={renderTitle}
      title={null}
      isScrollable={false}>
      <div className="d-flex flex-fill flex-column justify-content-start align-content-center h-100">
        <img
          style={{
            width: '100%',
            height: 'auto',
            marginTop: '6rem',
            resize: 'contain',
            alignSelf: 'center',
            marginBottom: '-2rem',
          }}
          src="./assets/images/warning.svg"
          alt="warning"
        />
        <div className="text-center mb-5">{translate('whitelist_delete_message')}</div>
        <ChecklistOption
          key={selectedWallet.id}
          title={selectedWallet.name || selectedWallet.coin}
          subTitle={maskCoinAddress(selectedWallet.wallet_address)}
          value={selectedWallet}
          withCheckbox={false}
          tag={selectedWalletTag}
          tagColor={tagColors[selectedWalletTag]}
          className="mb-2"
          isChecked
        />
      </div>
    </ModalBodyLayout>
  );
};

export default WhitelistDeleteAddress;

WhitelistDeleteAddress.propTypes = {
  openScreen: PropTypes.func.isRequired,
  wallet: PropTypes.shape({
    coin: PropTypes.string.isRequired,
  }).isRequired,
  options: PropTypes.object,
  isSendCryptoModal: PropTypes.bool,
};

WhitelistDeleteAddress.defaultProps = {
  options: null,
  isSendCryptoModal: true,
};
